import React from "react"
import { Card } from "react-bootstrap"
import { HiLockClosed, HiOutlineEyeOff, HiOutlineMenu } from "react-icons/hi"
import { useSortable } from "@dnd-kit/react/sortable"
import IonIcon from "../../../../components/ionIcon"
import { USER_ROLES } from "../../../../constants/userRoles"
import { twClassNames } from "../../../../helpers/classNames"
import { getLocaleValue } from "../../../../helpers/getLocaleValue"
import type { Guide } from "../../../../constants/types"

export const isLocked = (guide: Guide | undefined, role: string | undefined): boolean => {
  if (!guide) return true
  if (role === USER_ROLES.ADMIN || role === USER_ROLES.ACCOUNT_HOLDER) return false
  return !!guide.isLocked
}

type SortableGuideItemProps = {
  guide: Guide
  index: number
  language: string
  selected: boolean
  role: string | undefined
  onClick: (guide: Guide) => void
}

export const SortableGuideItem: React.FC<SortableGuideItemProps> = ({
  guide,
  index,
  language,
  selected,
  role,
  onClick
}) => {
  const { ref, isDragging } = useSortable({ id: guide.id, index })

  return (
    <div ref={ref}>
      <Card
        body
        className={twClassNames("guide", selected && "selected", isLocked(guide, role) && "locked")}
        style={isDragging ? { boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)" } : undefined}
        onClick={() => onClick(guide)}>
        <IonIcon name={guide.icon} style={undefined} />
        <span className="ml-3">{getLocaleValue(guide, "title", language)}</span>
        <HiOutlineMenu className="float-right mt-1" />
        {guide.isDraft && <HiOutlineEyeOff className="float-right mt-1 mr-1" />}
        {guide.isLocked && <HiLockClosed className="float-right mt-1 mr-1" />}
      </Card>
    </div>
  )
}
